import * as React from 'react';
import ConsentStateType from 'owa-service/lib/contract/ConsentStateType';
import { Dialog } from 'office-ui-fabric-react/lib/Dialog';
import { DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { observer } from 'mobx-react';
import { OutlookEventDispId, unregisterApiEvent } from 'owa-addins-events';
import {
    ActiveDialog,
    ActiveDialogType,
    extensibilityState,
    IAddinCommand,
} from 'owa-addins-store';

const styles = require('./UILessDialogWrapper.scss');

export interface UILessDialogWrapperProps {
    hostItemIndex: string;
    controlId: string;
    addinCommand: IAddinCommand;
    children?: any;
}

@observer
export default class UILessDialogWrapper extends React.Component<UILessDialogWrapperProps, any> {
    constructor(props: UILessDialogWrapperProps, context?: any) {
        super(props, context);
    }

    render(): JSX.Element {
        const dialog: ActiveDialog = extensibilityState.activeDialog;

        let isOpen = false;
        if (
            !!dialog &&
            dialog.parentControlId == this.props.controlId &&
            dialog.dialogType == ActiveDialogType.NonIFrameable
        ) {
            isOpen = true;
        }

        const addinCommand = this.props.addinCommand;
        const consentState = addinCommand.extension.ConsentState;
        const extensionType = addinCommand.extension.Type;
        const style =
            consentState != ConsentStateType.Consented && extensionType == 'Preinstalled'
                ? styles.consentContainer
                : styles.uiLessContainer;
        const dialogVisibility = isOpen ? '' : styles.hiddenContainer;

        return (
            <div>
                <Dialog
                    hidden={false}
                    onDismiss={this.hideDialog.bind(this)}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: addinCommand.extension.DisplayName,
                    }}
                    modalProps={{
                        isBlocking: isOpen,
                        containerClassName: styles.dialogContainer,
                        className: dialogVisibility,
                    }}
                    forceFocusInsideTrap={isOpen}
                    containerClassName={styles.dialogContainer}
                    isClickableOutsideFocusTrap={true}>
                    <div className={style}>{this.props.children}</div>
                </Dialog>
            </div>
        );
    }

    hideDialog = () => {
        unregisterApiEvent({
            eventDispId: OutlookEventDispId.DIALOG_NOTIFICATION_SHOWN_IN_ADDIN_DISPID,
            controlId: this.props.controlId,
        });
    };
}
